import { useEffect, useReducer } from "react";
import type { AbstractAgent } from "@ag-ui/client";

// Subscribes to the agent's lifecycle events and forces a re-render so
// consumers can read `agent.messages` / `agent.state` / `agent.isRunning`
// directly. Replaces CopilotKit's `useAgent` to avoid pulling in the chat-UI
// dependency chain (streamdown → katex), which we don't use.
export function useAgent(agent: AbstractAgent): AbstractAgent {
  const [, forceRerender] = useReducer((x: number) => x + 1, 0);
  useEffect(() => {
    const sub = agent.subscribe({
      onMessagesChanged: () => forceRerender(),
      onStateChanged: () => forceRerender(),
      onRunStartedEvent: () => forceRerender(),
      onRunFinishedEvent: () => forceRerender(),
      onRunFailed: () => forceRerender(),
    });
    return () => sub.unsubscribe();
  }, [agent]);
  return agent;
}
